import { postRequest, getRequest } from "app/axiosClient";
import {
  showLoader,
  hideLoader,
} from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import {
  setClientsList,
  setClientDetailsById,
  setPartnerClientsList,
  setPartnerClientDetailsById,
  setEstimatesList,
  setEstimateAttachments,
  setEstimateById,
  setWorkOrdersList,
  setWorkOrderDetails,
  setClientsByPartnerClientsList,
  setFindClientList,
  setClientsCount,
  setPartnerClientsCount,
  setEstimateListByCompanyId,
  setWorkOrderItemList,
  setWorkOrdersListByCompanyId,
  setProjectsListBySubClientId,
  setInvoicesListByCompanyId,
} from "./ClientsSlice";
import { getInvoicesList } from "../Invoices/InvoicesSlice";
import { resetAttachments } from "CommonComponents/Attachments/AttachmentsSlice";
import { uploadAttachment } from "CommonComponents/Attachments/AttachmentsAPI";

export const GetClientsListApi = (Pagination) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Client/GetClientsList`, Pagination)
      .then((res) => {
        dispatch(
          setClientsList({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Clients.Notification.UnexpectedError",
      "",
      "Clients.Notification.Anunexpectederroroccurred"
    );
  }
};

export const AddClientApi = (clientData, Pagination) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/AddClient`, clientData)
      .then((res) => {
        dispatch(hideLoader());
        if (!clientData?.partnerClientId) {
          dispatch(GetClientsListApi(Pagination));
        } else {
          dispatch(
            GetClientsByPartnerClientId(clientData?.partnerClientId, Pagination)
          );
        }
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Clients.Notification.Clientaddedsuccessfully"
        );
        dispatch(getTotalClientsCountAPI());
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          e.status == 409
            ? "Clients.Notification.ClientDuplicate"
            : "Clients.Notification.UnexpectedError"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Clients.Notification.Anunexpectederroroccurredwhileaddingclient"
    );
    return false;
  }
};

export const EditClientApi = (clientData, Pagination) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/EditClient`, clientData)
      .then((res) => {
        dispatch(hideLoader());
        dispatch(GetClientByIdApi(clientData?.id));
        if (!clientData?.partnerClientId) {
          dispatch(GetClientsListApi(Pagination));
        } else {
          dispatch(
            GetClientsByPartnerClientId(clientData?.partnerClientId, Pagination)
          );
        }
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Clients.Notification.Clienthasbeenupdatedsuccessfully"
        );
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          e.status == 409
            ? "Clients.Notification.ClientDuplicate"
            : "Clients.Notification.UnexpectedError"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Clients.Notification.Anunexpectederroroccurredwhileupdatingclient"
    );
    return false;
  }
};

export const GetClientByIdApi = (Id) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Client/GetClientById/${Id}`)
      .then((res) => {
        // dispatch(
        //   setClientsList({
        //     data: res?.data?.items,
        //     totalPages: res?.data?.totalPages,
        //   })
        // );
        dispatch(setClientDetailsById(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Clients.Notification.Anerroroccurredwhileretrievingclientdetails"
    );
  }
};

export const getClientEstimatesListApi =
  (clientId, pagination) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(
        `api/Client/GetEstimatesListByClientId?clientId=${clientId}`,
        pagination
      )
        .then((res) => {
          dispatch(
            setEstimatesList({
              data: res?.data?.items,
              totalPages: res?.data?.totalPages,
            })
          );
          dispatch(hideLoader());
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Estimates.Notification.Anerroroccurredwhileretrievingestimates"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Estimates.Notification.Anerroroccurredwhileretrievingestimates"
      );
    }
  };

export const getPartnerEstimatesListApi =
  (partnerId, pagination) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(
        `api/Client/GetEstimatesListByPartnerId?partnerId=${partnerId}`,
        pagination
      )
        .then((res) => {
          dispatch(
            setEstimatesList({
              data: res?.data?.items,
              totalPages: res?.data?.totalPages,
            })
          );
          dispatch(hideLoader());
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Estimates.Notification.Anerroroccurredwhileretrievingestimates"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Estimates.Notification.Anerroroccurredwhileretrievingestimates"
      );
    }
  };

export const addEstimateAPI = (estimateInfo) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/UpsertQuote`, estimateInfo)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Estimates.Notification.EstimateAddedSuccessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
        return false;
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Estimates.Notification.Anunexpectederroroccurredwhileaddingestimate"
    );
    return false;
  }
};

export const editEstimateAPI = (estimateInfo) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/EditEstimate`, estimateInfo)
      .then((res) => {
        dispatch(setEstimatesList(res?.data));
        dispatch(resetAttachments());
        dispatch(uploadAttachment(res?.data));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Estimates.Notification.Estimatehasbeenupdatedsuccessfully"
        );
        return true;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
        return false;
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Estimates.Notification.Anunexpectederroroccurredwhileupdatingestimate"
    );
    return false;
  }
};

export const getEstimateByIdAPI = (Id) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Client/GetEstimateById/${Id}`)
      .then((res) => {
        // dispatch(
        //   setClientsList({
        //     data: res?.data?.items,
        //     totalPages: res?.data?.totalPages,
        //   })
        // );
        dispatch(setEstimateById(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Estimates.Notification.Unabletogetestimatedetails"
    );
  }
};

export const getEstimateAttachmentsAPI = (estimateId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Client/GetEstimateAttachmentsList?estimateId=${estimateId}`)
      .then((res) => {
        dispatch(setEstimateAttachments(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        // OpenNotificationWithIcon(
        //   "erreur",
        //   "Unexpected Error",
        //   "An unexpected erreur occurred while fetching files."
        // );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Estimates.Notification.Anunexpectederroroccurredwhilefetchingfiles"
    );
  }
};

export const uploadEstimateAttachmentsAPI = (input) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/UploadEstimateAttachments`, input)
      .then((res) => {
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Estimates.Notification.FileuploadedSuccessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
        return false;
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Estimates.Notification.Anunexpectederroroccurredwhileuploadingfile"
    );
    return false;
  }
};

export const removeEstimateAttachmentByIdAPI =
  (file, estimateId) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(`api/Client/DeleteEstimateAttachment/${file?.uid}`)
        .then((res) => {
          dispatch(getEstimateAttachmentsAPI(estimateId));
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Estimates.Notification.FiledeletedSuccessfully"
          );
        })
        .catch((e) => {
          const errorMessage = e?.response?.data?.Message || e?.message;
          dispatch(hideLoader());
          OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
        });
    } catch {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Estimates.Notification.Anunexpectederroroccurredwhiledeletingfile"
      );
    }
  };

export const addWorkOrderAPI = (workOrderInfo) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/AddWorkOrderWithOutQuote`, workOrderInfo)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "WorkOrder.Notification.WorkOrderAddedSuccessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
        return false;
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "WorkOrder.Notification.AnunexpectederroroccurredwhileaddingWorkOrder"
    );
    return false;
  }
};

export const GetWorkOrdersListByClientId = (pagination, id) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(
      `api/Client/GetWorkOrdersListByClientId?clientId=${id}`,
      pagination
    )
      .then((res) => {
        dispatch(
          setWorkOrdersList({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "WorkOrders.Notification.Anerroroccurredwhileretrievingworkorders"
    );
  }
};

export const GetWorkOrdersListByPartnerId = (pagination, id) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(
      `api/Client/GetWorkOrdersListByPartnerId?partnerId=${id}`,
      pagination
    )
      .then((res) => {
        dispatch(
          setWorkOrdersList({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "WorkOrders.Notification.Anerroroccurredwhileretrievingworkorders"
    );
  }
};
export const GetWorkOrderByIdApi = (workOrderId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Client/GetWorkOrderById?Id=${workOrderId}`)
      .then((res) => {
        dispatch(setWorkOrderDetails(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "WorkOrders.Notification.Anerroroccurredwhileretrievingworkorderdetails"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "WorkOrders.Notification.Anerroroccurredwhileretrievingworkorderdetails"
    );
  }
};
export const GetWorkOrderItemsByWorkOrderIdApi =
  (input, workOrderId) => (dispatch) => {
    try {
      dispatch(showLoader());
      return postRequest(
        `api/Client/GetWorkOrderItemsByWorkOrderId?workOrderId=${workOrderId}`,
        input
      )
        .then((res) => {
          dispatch(setWorkOrderItemList(res?.data));
          dispatch(hideLoader());
          return { payload: res?.data };
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "WorkOrders.Notification.Anerroroccurredwhileretrievingworkorderitems"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "WorkOrders.Notification.Anerroroccurredwhileretrievingworkorderitems"
      );
    }
  };
export const AddWorkOrderItemApi =
  (workOrderId, payload, input) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(
        `api/Client/AddWorkOrderItem?workOrderId=${workOrderId}`,
        payload
      )
        .then((res) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "WorkOrder.Notification.WorkOrderItemAddSuccess"
          );
          dispatch(GetWorkOrderItemsByWorkOrderIdApi(input, workOrderId));
        })
        .catch((e) => {
          dispatch(hideLoader());
          const errorMessage = e?.response?.data?.Message || e.message;
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            errorMessage,
            "WorkOrder.Notification.WorkOrderItemAddFailed"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "WorkOrders.Notification.WorkOrderItemAddFailed"
      );
    }
  };
export const UpdateWorkOrderItemApi =
  (workOrderId, itemId, payload, input) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(
        `api/Client/UpdateWorkOrderItem?workOrderItemId=${itemId}`,
        payload
      )
        .then((res) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "WorkOrder.Notification.WorkOrderItemUpdateSuccess"
          );
          dispatch(GetWorkOrderItemsByWorkOrderIdApi(input, workOrderId));
        })
        .catch((e) => {
          dispatch(hideLoader());
          const errorMessage = e?.response?.data?.Message || e.message;
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            errorMessage,
            "WorkOrder.Notification.WorkOrderItemUpdateFailed"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "WorkOrder.Notification.WorkOrderItemUpdateFailed"
      );
    }
  };
export const DeleteWorkOrderItemApi =
  (workOrderId, itemId, input) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(`api/Client/DeleteWorkOrderItem?workOrderItemId=${itemId}`)
        .then((res) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "WorkOrder.Notification.WorkOrderItemDeleteSuccess"
          );
          dispatch(GetWorkOrderItemsByWorkOrderIdApi(input, workOrderId));
        })
        .catch((e) => {
          dispatch(hideLoader());
          const errorMessage = e?.response?.data?.Message || e.message;
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            errorMessage,
            "WorkOrder.Notification.WorkOrderItemDeleteFailed"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "WorkOrder.Notification.WorkOrderItemDeleteFailed"
      );
    }
  };
export const UpdateWorkOrderApi = (workOrderData) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/UpdateWorkOrder`, workOrderData)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "WorkOrders.Notification.WorkOrderUpdatedSuccessfully"
        );
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "WorkOrders.Notification.Anunexpectederroroccurredwhileupdatingworkorder"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "WorkOrders.Notification.Anunexpectederroroccurredwhileupdatingworkorder"
    );
    return false;
  }
};

export const SendEmailForQuoteAcceptance = (estimateInfo) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/SendEmailForQuoteAcceptance`, estimateInfo)
      .then((res) => {
        //dispatch(getEstimatesListApi(estimateInfo?.clientId, input));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Estimates.Notification.Estimatehasbeensubmittedsuccessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon("error", "Common.Error", errorMessage, "");
        return false;
      });
  } catch {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Estimates.Notification.Anunexpectederroroccurredwhilesubmittingestimate"
    );
    return false;
  }
};
export const GetEstimatePdfApi = (estimateId) => (dispatch) => {
  try {
    const selectedLanguage =
      localStorage.getItem("selectedlanguage") || "en-US";
    dispatch(showLoader());
    return getRequest(
      `api/Pdf/EstimatePdf?estimateId=${estimateId}&culture=${selectedLanguage}`
    )
      .then((res) => {
        dispatch(hideLoader());
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          e.response?.data?.Message,
          ""
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Estimates.Notification.Anunexpectederroroccurredwhilefetchingpdf"
    );
    return false;
  }
};

export const GetWorkOrderPdfApi = (estimateId) => (dispatch) => {
  try {
    const selectedLanguage =
      localStorage.getItem("selectedlanguage") || "en-US";
    dispatch(showLoader());
    return getRequest(
      `api/Pdf/WorkOrderPdf?estimateId=${estimateId}&culture=${selectedLanguage}`
    )
      .then((res) => {
        dispatch(hideLoader());
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          e.response?.data?.Message,
          ""
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Estimates.Notification.Anunexpectederroroccurredwhilefetchingpdf"
    );
    return false;
  }
};

export const GetPartnerClientsListApi = (Pagination) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Client/GetPartnerClientsList`, Pagination)
      .then((res) => {
        dispatch(
          setPartnerClientsList({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Clients.Notification.UnexpectedError",
      "",
      "PartnerCLient.Notification.Anunexpectederroroccurred"
    );
  }
};

export const AddPartnerClientApi = (clientData, Pagination) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/AddPartnerClient`, clientData)
      .then((res) => {
        dispatch(hideLoader());
        dispatch(GetPartnerClientsListApi(Pagination));
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "PartnerCLient.Notification.Clientaddedsuccessfully"
        );
        dispatch(getPartnerClientsCountAPI());
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          e.status == 409
            ? "Clients.Notification.PartnerDuplicate"
            : "Clients.Notification.UnexpectedError"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "PartnerCLient.Notification.Anunexpectederroroccurredwhileaddingclient"
    );
    return false;
  }
};

export const EditPartnerClientApi = (clientData, Pagination) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/EditPartnerClient`, clientData)
      .then((res) => {
        dispatch(hideLoader());
        dispatch(GetPartnerClientsListApi(Pagination));
        dispatch(GetPartnerClientByIdApi(clientData?.id));
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "PartnerCLient.Notification.Clienthasbeenupdatedsuccessfully"
        );
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          e.status == 409
            ? "Clients.Notification.PartnerDuplicate"
            : "Clients.Notification.UnexpectedError"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "PartnerCLient.Notification.Anunexpectederroroccurredwhileupdatingclient"
    );
    return false;
  }
};

export const GetPartnerClientByIdApi = (Id) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Client/GetPartnerClientById/${Id}`)
      .then((res) => {
        dispatch(setPartnerClientDetailsById(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "PartnerCLient.Notification.Anerroroccurredwhileretrievingclientdetails"
    );
  }
};
export const GetClientsByPartnerClientId = (Id, Pagination) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Client/GetClientsByPartnerClientId/${Id}`, Pagination)
      .then((res) => {
        dispatch(
          setClientsByPartnerClientsList({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Clients.Notification.UnexpectedError",
      "",
      "Clients.Notification.Anunexpectederroroccurred"
    );
  }
};

export const FindClientListApi = (searchTerm) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Client/FindClientsList?SearchQuery=${searchTerm}`)
      .then((res) => {
        dispatch(
          setFindClientList({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Clients.Notification.UnexpectedError",
      "",
      "Clients.Notification.Anunexpectederroroccurred"
    );
  }
};

export const getTotalClientsCountAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest("api/Client/GetTotalClientsCount")
      .then((res) => {
        dispatch(setClientsCount(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorretrievingroles"
    );
  }
};

export const getPartnerClientsCountAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest("api/Client/GetTotalPartnerClientsCount")
      .then((res) => {
        dispatch(setPartnerClientsCount(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorretrievingroles"
    );
  }
};

export const AddSignatureApi = (signatureData) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Client/AddDigitalSignature`, signatureData)
      .then((res) => {
        dispatch(hideLoader());

        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "DigitalSignature.Notification.SignatureSavedSuccessfully"
        );

        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "DigitalSignature.Notification.UnexpectedError"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "DigitalSignature.Notification.UnexpectedError"
    );
    return false;
  }
};

export const previewEstimateAPI = (estimateInfo) => (dispatch) => {
  try {
    const selectedLanguage =
      localStorage.getItem("selectedlanguage") || "en-US";
    dispatch(showLoader());
    return postRequest(
      `api/Pdf/PreviewQuotePdf?culture=${selectedLanguage}`,
      estimateInfo
    )
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "AddEstimate.Notification.PreviewGeneratedSucessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "AddEstimate.Notification.PreviewGeneratedError"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "AddEstimate.Notification.PreviewGeneratedError"
    );
    return false;
  }
};

export const previewWorkOrderAPI = (estimateInfo) => (dispatch) => {
  try {
    const selectedLanguage =
      localStorage.getItem("selectedlanguage") || "en-US";
    dispatch(showLoader());
    return postRequest(
      `api/Pdf/PreviewWOPdf?culture=${selectedLanguage}`,
      estimateInfo
    )
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "AddEstimate.Notification.PreviewGeneratedSucessfully"
        );
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "AddEstimate.Notification.PreviewGeneratedError"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "AddEstimate.Notification.PreviewGeneratedError"
    );
    return false;
  }
};
export const getInvoicesByCompanyId = (searchParams) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Client/GetInvoicesListByCompanyId`, searchParams)
      .then((res) => {
        dispatch(
          setInvoicesListByCompanyId({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "WorkOrder.Notification.AnErrorOccurredWhileRetrievingWorkOrders"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "WorkOrder.Notification.AnErrorOccurredWhileRetrievingWorkOrders"
    );
  }
};
export const getWorkOrdersByCompanyId = (searchParams) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Client/GetWorkOrdersListByCompanyId`, searchParams)
      .then((res) => {
        dispatch(
          setWorkOrdersListByCompanyId({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
          })
        );
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "WorkOrder.Notification.AnErrorOccurredWhileRetrievingWorkOrders"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "WorkOrder.Notification.AnErrorOccurredWhileRetrievingWorkOrders"
    );
  }
};
export const getProjectsListBySubClientId =
  (searchParams, subClientId) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(
        `api/Project/GetProjectsList?subClientId=${subClientId}`,
        searchParams
      )
        .then((res) => {
          dispatch(
            setProjectsListBySubClientId({
              data: res?.data?.items,
              totalPages: res?.data?.totalPages,
            })
          );
          dispatch(hideLoader());
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Project.Notification.AnErrorOccurredWhileRetrievingProjects"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Project.Notification.AnErrorOccurredWhileRetrievingProjects"
      );
    }
  };
export const getQuotesListByProjectId =
  (pagination, projectId) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(
        `api/Project/GetQuotesListByProjectId?projectId=${projectId}`,
        pagination
      )
        .then((res) => {
          dispatch(
            setEstimatesList({
              data: res?.data?.items,
              totalPages: res?.data?.totalPages,
            })
          );
          dispatch(hideLoader());
        })
        .catch(() => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Quote.Notification.AnErrorOccurredWhileRetrievingQuotes"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Quote.Notification.AnErrorOccurredWhileRetrievingQuotes"
      );
    }
  };
export const getWorkOrdersListByProjectId =
  (searchParams, projectId) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(
        `api/Project/GetWorkOrdersListByProjectId?projectId=${projectId}`,
        searchParams
      )
        .then((res) => {
          dispatch(
            setWorkOrdersList({
              data: res?.data?.items,
              totalPages: res?.data?.totalPages,
            })
          );
          dispatch(hideLoader());
        })
        .catch(() => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "WorkOrder.Notification.AnErrorOccurredWhileRetrievingWorkOrders"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "WorkOrder.Notification.AnErrorOccurredWhileRetrievingWorkOrders"
      );
    }
  };
export const UpsertProjectApi = (input, filter, subClientId) => (dispatch) => {
  try {
    dispatch(showLoader());

    return postRequest(`api/Project/UpsertProject`, input)
      .then((res) => {
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Project.Notification.ProjectSaved"
        );
        dispatch(getProjectsListBySubClientId(filter, subClientId));
        dispatch(hideLoader());
        return true;
      })
      .catch((e) => {
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          e.response?.data?.InnerException?.Message,
          "Project.Notification.ProjectSaveError"
        );
        dispatch(hideLoader());
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Project.Notification.ProjectSaveError"
    );
    return false;
  }
};
